{
  const partners = document.querySelectorAll('[data-partners-open]');  
  const openPartners = document.querySelector('[data-partners-button]');   
 
  if (openPartners) {
    openPartners.onclick = function() {
      if (openPartners.classList.contains('partners__arrow--up')) {	
        partners.forEach((item) => {		
		  item.classList.remove('pulse-diagnostics--open');
	      item.classList.add('pulse-diagnostics--hide');
        });	  
	    openPartners.classList.remove('partners__arrow--up');
	    openPartners.classList.add('partners__arrow--down');
	  } else {	  
	    partners.forEach((item) => {		
	      item.classList.remove('pulse-diagnostics--hide');
	      item.classList.add('pulse-diagnostics--open');
        });
	    openPartners.classList.remove('partners__arrow--down');
	    openPartners.classList.add('partners__arrow--up');
	  }
    }
  }
}
